import PrivacyPolicy from '@/assets/betroyale/pdf/privacy_policy.pdf';
import TermsAndConditions from '@/assets/betroyale/pdf/terms_and_conditions.pdf';

export default {
  PrivacyPolicy,
  TermsAndConditions,
};
